export default "__VITE_ASSET__BA5wJ4vO__"